<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte Pólizas Asignadas</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_01_Beneficio</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row class="mt-3">
            <b-col>
              <b-form-group align="left">
                <label>Fecha de inicio</label>
                <b-input-group size="sm" class="mb-2" id="fci" lab>
                  <b-form-datepicker
                    name="nombre"
                    placeholder="Fecha de Inicio"
                    v-model="$v.filtro.fechaInicio.$model"
                    :state="validateState('fechaInicio')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Fecha de fin</label>
                <b-input-group size="sm" class="mb-2" id="fcf" lab>
                  <b-form-datepicker
                    name="nombre"
                    placeholder="Fecha de Fin"
                    :min="filtro.fechaInicio"
                    :max="new Date()"
                    v-model="$v.filtro.fechaFin.$model"
                    :state="validateState('fechaFin')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row align-v="center" align-h="end" >
            <b-col>
              <b-form-group align="left">
                <label>Clínicas</label>
                <v-select
                  style="width: 100%"
                  name="clinica"
                  placeholder="--Seleccionar--"
                  label="nombreClinica"
                  multiple
                  :reduce="(variable) => variable.idClinica"
                  :options="listaClinicas"
                  v-model="filtro.clinica"
                  ><span slot="no-options">No hay clínicas disponibles</span>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="1" >
              <b-button
                v-if="todas == true"
                class="btnn"
                variant="outline-primary"
                v-b-tooltip.hover
                @click="todos()"
              >
                <b-icon icon="check2-all"></b-icon>
                <span class="labels">Seleccionar Todas</span>
              </b-button>
              <b-button
              v-else
                class="btnn"
                variant="outline-primary"
                v-b-tooltip.hover
                @click="clear()"
              >
                <b-icon icon="x"></b-icon>
                <span class="labels">Quitar todas</span> 
              </b-button>
            </b-col>
            
          </b-row>

          <b-row>
            <b-col></b-col>
            <b-col></b-col>
            <b-col class="text-right">
              <span v-if="$localStorageService.can('RP_01_Excel_BBVA')">
                <download-excel
                  v-if="datosTabla.length > 0"
                  class="btn btn-outline-success mr-4"
                  :data="datosTabla"
                  :fields="fieldsExcel"
                  worksheet="ReportePolizas"
                  :name="
                    'ReportePolizasAsignadas-' +
                    $formatoFecha(new Date()) +
                    '.xls'
                  "
                >
                  Generar Excel
                  <em class="fa fa-file-excel-o"></em>
                </download-excel>
              </span>
              <b-button
                variant="outline-primary"
                :disabled="loader"
                @click="obtenerDatos()"
              >
                <span v-if="!loader">Buscar</span>
                <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>

      <b-row>
        <b-col cols="12">
          <b-table
            thead-tr-class="columnas"
            :items="datosTabla"
            :fields="fields"
            :per-page="$registrosPorPaginaTabla"
            :current-page="paginaActual"
            responsive
            class="parrafos"
          >
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert
              v-if="datosTabla !== undefined && datosTabla.length === 0"
              variant="warning"
              show
              >No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
              v-if="datosTabla !== undefined && datosTabla.length > 10"
              align="center"
              v-model="paginaActual"
              :total-rows="datosTabla.length"
              :per-page="$registrosPorPaginaTabla"
              aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header";
import { required } from "vuelidate/lib/validators";
export default {
  components: {
    Header,
  },
  name: "ReporteAsignacionPolizas",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      todas: true,
      paginaActual: 0,
      listaClinicas: [],
      loader: false,
      datosTabla: [],
      fields: [],
      filtro: {
        fechaInicio: null,
        fechaFin: null,
        clinica: [],
      },
      fieldsExcel: {
        "NO. PÓLIZA": "poliza",
        "NO. CERTIFICADO": "certificado",
        "CLINICA": "clinica",
        "NOMBRE DEL PX": "paciente",
        "ID PACIENTE": "idPaciente",
        "FECHA DE NACIMIENTO": "fechaNacimiento",
        "FECHA DE ASIGNACIÓN": "fechaAlta",
        "CLINICA ASIGNACIÓN": "clinicaAsignacion",
      },
    };
  },

  validations: {
    filtro: {
      fechaInicio: { required },
      fechaFin: { required },
    },
  },
  mounted() {
    this.fields = [
      { key: "poliza", label: "No. Póliza", sortable: true },
      { key: "certificado", label: "No. Certificado", sortable: true },
      { key: "clinica", label: "Clínica Cita", sortable: true },
      { key: "paciente", label: "Nombre del PX", sortable: true },
      { key: "idPaciente", label: "ID Paciente", sortable: true },
      { key: "fechaNacimiento", label: "Fecha de Nacimiento", sortable: true },
      { key: "fechaAlta", label: "Fecha de Asignación", sortable: true },
      { key: "clinicaAsignacion", label: "Clinica de Asignación", sortable: true}
    ];
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.llenarClinicas();
  },
  methods: {
    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
    },

    obtenerDatos() {
      this.$v.filtro.$touch();

      if (this.filtro.clinica.length == 0) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar al menos una clínica para realizar la búsqueda",
        });
      } else {
        if (!this.$v.filtro.$invalid) {
          this.loader = true;
          this.datosTabla = [];

          const idsClinica = [];
          this.filtro.clinica.forEach((it) => {
            if (it instanceof Object) {
              idsClinica.push(it.idClinica);
            } else {
              idsClinica.push(it);
            }
          });

          const filtro = {
            fechaInicio:
              this.filtro.fechaInicio !== null
                ? this.$moment(this.filtro.fechaInicio).format(
                    "YYYY-MM-DD[T]HH:mm:ssZ"
                  )
                : null,
            fechaFin:
              this.filtro.fechaFin !== null
                ? this.$moment(this.filtro.fechaFin).format(
                    "YYYY-MM-DD[T]HH:mm:ssZ"
                  )
                : null,
            clinica: idsClinica,
          };

          this.$http
            .post(this.$api + "reportes/polizasAsignadas", filtro)
            .then((respuesta) => {
              if (respuesta.data.data) {
                this.datosTabla = respuesta.data.data;
              }
            })
            .finally(() => {
              this.loader = false;
              this.paginaActual = 0;
            });
        } else {
          return false;
        }
      }
    },

    todos() {
      this.todas = false;
      this.filtro.clinica = this.listaClinicas;
    },

    clear(){
      this.todas = true;
      this.filtro.clinica = [];
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>

<style scoped>
  .btnn{
    display: flex;
    font-size: 11px;
    width: 135px;
    align-items: center;
  }
  .labels{
    padding-left: 5px;
  }
</style>
